import React from "react";
import { Col, Row } from "react-bootstrap";
import { object, number, array } from "prop-types";
import AverageScoreScale from "components/DynamicScoreReportScales/AverageScoreScale";
import exceededCheckCircle from "resources/images/dynamic_score_reports/skills/score-report/check-circle.png";
import currentCheckCircle from "resources/images/dynamic_score_reports/skills/score-report/hollow-check-circle.svg";
import { clptExpressSubTestIds } from "utils/helperConstants";
import { dynamicTraitFieldToPretty } from "../../constants";

const CLPT = (props) => {
  const {
    candidateInfo,
    SelectedScoreRangeSection,
    SubcategoryScoreColumns,
    testId,
    testScores,
  } = props;

  const score = testScores.get("stwenty");
  const isClptExpress = clptExpressSubTestIds.includes(
    String(testScores.get("subTestId"))
  );

  const ResultsDetails = (
    <div className="gray-bottom-border py-3 px-1">
      <h3 className="reportHeader pb-2">Results Details</h3>
      <p>
        Candidates receive a score from 1-20 and a proficiency rating from
        Beginner to Advanced. The score is a numerical reflection of the
        candidate's proficiency.
      </p>
      <p>
        {candidateInfo.get("testTakerFirstName")} received a score of {score},
        indicating that their proficiency is at the {testScores.get("label")}{" "}
        level.
      </p>
      <div className="mx-3">
        <AverageScoreScale score={score} testId={testId} />
      </div>
      <Row className="pt-4 pb-1">
        <Col>
          <div className="mb-2">
            <img
              src={currentCheckCircle}
              alt="Current level"
              width="24"
              height="24"
              className="currentCheckCircle"
            />
            Indicates the current level of proficiency for the candidate.
          </div>
          <div>
            <img
              src={exceededCheckCircle}
              alt="Exceeded level"
              width="20"
              height="20"
              className="exceededCheckCircle"
            />
            Indicates the candidate has exceeded this level of proficiency.
          </div>
        </Col>
      </Row>
      {SelectedScoreRangeSection && (
        <Row className="mx-3 mt-4">{SelectedScoreRangeSection}</Row>
      )}
    </div>
  );

  // ---------------------------- Score Details ---------------------------
  const getScoreDetails = () => (
    <Row className="gray-bottom-border pt-3 px-1">
      <Col>
        <h3 className="reportHeader pb-2">Score Details</h3>
        <div className="d-flex">{SubcategoryScoreColumns}</div>
      </Col>
    </Row>
  );

  const getCEFRSection = () => {
    const cefrScoreBoxes = ["readingCEFR", "listeningCEFR", "writingCEFR"].map(
      (cefrLevelField) => {
        const cefrLevel = testScores.get(cefrLevelField);

        return cefrLevel ? (
          <Col key={cefrLevelField} style={{ paddingRight: "36px" }}>
            <Row
              className="criteria-navy-color traitDescriptionBox font-weight-bold"
              style={{ height: "36px", flexWrap: "nowrap" }}
            >
              <Col xs={8} className="d-flex align-items-center">
                <h3
                  className="mb-0 font-weight-bold"
                  style={{
                    fontSize: "16px",
                  }}
                >
                  {dynamicTraitFieldToPretty[testId][cefrLevelField]}
                </h3>
              </Col>
              <Col
                className="text-right pr-4"
                style={{ fontSize: "20px", marginTop: "-9px" }}
              >
                {cefrLevel}
              </Col>
            </Row>
          </Col>
        ) : null;
      }
    );

    return (
      <Row className="py-3 px-1">
        <Col>
          <h3 className="reportHeader pb-2">CEFR</h3>
          <p>
            The Common European Framework of Reference for Languages (CEFR) is a
            widely accepted international guideline used to describe language
            ability.
          </p>
          <p>
            The CEFR spans six levels from A1 (Beginner) to C2 (Proficiency).
            Scores from the CLPT - English are equated to the CEFR levels for
            those who wish to use it.
          </p>
          <div className="d-flex mt-4s">{cefrScoreBoxes}</div>
        </Col>
      </Row>
    );
  };

  return (
    <div>
      {ResultsDetails}
      {!isClptExpress && (
        <div>
          {getScoreDetails()}
          {getCEFRSection()}
        </div>
      )}
    </div>
  );
};

CLPT.propTypes = {
  candidateInfo: object,
  SelectedScoreRangeSection: object,
  SubcategoryScoreColumns: array,
  testId: number,
  testScores: object,
};

export default CLPT;
